import dateUtils from './dateUtils';

const date = new Date();

const todayObj = {
    day: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear()
};

function getToday() {
    return todayObj;
}

function getTodaysMonthString() {
    return `${todayObj.year} ${todayObj.month + 1}`;
}

function isToday(day, today) {
    if (!today) {
        today = getToday();
    }

    if (day) {
        return day.year === today.year && day.month === today.month && day.day === today.day;
    }

    return false;
}

function isPast(day, today) {
    if (!today) {
        today = getToday();
    }

    if (day) {
        return dateUtils.compareDateStrings(dateUtils.getDayToString(day), dateUtils.getDayToString(today)) > 0;
    }

    return false;
}

export default {getToday, getTodaysMonthString, isToday, isPast};
